import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  cloudinary: {
    id: 'cloudinary',
    defaultMessage: 'Cloudinary',
  },
  appName: {
    id: 'appName',
    defaultMessage: 'Settings',
  },
  notFound: {
    id: 'notFound',
    defaultMessage: 'Not Found',
  },
  pageNotFoundTitle: {
    id: 'pageNotFoundTitle',
    defaultMessage: "The page you've requested doesn't exist.",
  },
  pageNotFoundMessage: {
    id: 'pageNotFoundMessage',
    defaultMessage: 'You may have mistyped the address or the page may have moved.',
  },
});
